import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ExportXmlService {
    downloadXmlFile(xmlContent: string): void {
        const blob = new Blob([xmlContent], { type: 'application/xml' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `eton-sequencing-order-${new Date().getTime()}.xml`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
}
